<template>
  <div class="main-container">
    <div class="form main-container-item">
        <h2 class="title">Enter your credit card information</h2>
        <h3 class="subtitle">You will not be billed for your first 30 days. Cancel any time.</h3>
        
        <div class="form__container">
        <div class="form__line">
          <label class="form__label" for="card">Credit card number</label>
          <div id="card-number" class="form__input" :class="{ 'uk-form-danger': cardNumberError }" @click="fixFields"/>
        </div>
        <div class="form__line">
          <div class="form__item">
            <label class="form__label" for="date">Expiration date</label>
            <div id="card-expiry" class="form__input" :class="{ 'uk-form-danger': cardExpiryError }" @click="fixFields"/>
          </div>
          <div class="form__item">
            <label class="form__label" for="cvc">CVC</label>
            <div id="card-cvc" class="form__input" :class="{ 'uk-form-danger': cardCvcError }" @click="fixFields" />
          </div>
        </div>
        <div class="form__line">
          <label class="form__label" for="name">Name on card</label>
          <input
            class="form__input"
            v-model="cardName"
            placeholder="Enter name on card"
            :class="{ 'uk-form-danger': cardNameError }"
            name="name"
            @click="fixFields"
          />
        </div>
        <button
          class="form__btn"
          type="button"
          @click.prevent="submitFormToCreateToken()"
        >Review</button>
      </div>
    </div>
  </div>
</template>

<script>
import { fixHeight, changeRoute } from "@/js/util.js";

export default {
  name: 'CreditCard',
  data() {
    return {
      cardNumberError: '',
      cardExpiryError: '',
      cardNameError: '',
      cardCvcError: '',
      cardName: '',
      card: {
        number: '',
        expiry: '',
        cvc: ''
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
          let t = this;
          setTimeout(() => {
            if (window.innerWidth > 768) {
              t.fixHeight(document.querySelectorAll(".main-container-item"));
            }
            t.setUpStripe();
            t.fixFields();
          }, 550);
        });
  },
  methods: {
    fixHeight,
    listenForErrors() {
      const vm = this;

      this.cardNumber.addEventListener("change", (event) => {
        vm.toggleError(event);
        vm.cardNumberError = "";
        vm.card.number = event.complete ? true : false;
      });

      this.cardExpiry.addEventListener("change", (event) => {
        vm.toggleError(event);
        vm.cardExpiryError = "";
        vm.card.expiry = event.complete ? true : false;
      });

      this.cardCvc.addEventListener("change", (event) => {
        vm.toggleError(event);
        vm.cardCvcError = "";
        vm.card.cvc = event.complete ? true : false;
      });
    },
    toggleError(event) {
      if (event.error) {
        this.stripeError = event.error.message;
      } else {
        this.stripeError = "";
      }
    },
    setUpStripe() {
      if (window.Stripe === undefined) {
        alert("Stripe V3 library not loaded!");
      } else {
        const stripe = window.Stripe(window.config.stripeKey);
        this.stripe = stripe;
        const elements = stripe.elements();
        const inputStyle = {
          base: {
            fontFamily: '"Open Sans", Helvetica, sans-serif',
            fontSize: "14px",
            lineHeight: "43px",
            "::placeholder": {
              fontFamily: '"Open Sans", Helvetica, sans-serif',
              fontSize: "14px",
              fontWeight: "300",
            },
          },
        };
        this.cardCvc = elements.create("cardCvc", {
          placeholder: "Enter CVC",
          style: inputStyle
        });
        this.cardExpiry = elements.create("cardExpiry", {
          placeholder: "Enter date",
          style: inputStyle
        });
        this.cardNumber = elements.create("cardNumber", {
          placeholder: "Enter credit card number",
          style: inputStyle
        });

        this.cardCvc.mount("#card-cvc");
        this.cardExpiry.mount("#card-expiry");
        this.cardNumber.mount("#card-number");

        this.listenForErrors();
      }
		},
    submitFormToCreateToken() {

      changeRoute(this, "/signup#signup");
      return;
      // this.clearCardErrors();

      this.loading = true;
      let valid = true;

      if (!this.accept) {
        valid = false;
      }

      if (!this.card.number) {
        valid = false;
        this.cardNumberError = "Card Number is Required";
      }
      if (!this.card.cvc) {
        valid = false;
        this.cardCvcError = "CVC is Required";
      }
      if (!this.card.expiry) {
        valid = false;
        this.cardExpiryError = "Card Expiration is Required";
      }
      if (!this.card.name) {
        valid = false;
        this.cardNameError = "Name is Required";
      }

      if (this.stripeError) {
        valid = false;
      }

      if (valid) {
        this.createToken();
      } else {
        this.loading = false;
      }
    },
    createToken() {
      this.stripe
        .createToken(
          this.card.number, {
          name: this.card.name
        })
        .then((result) => {
          if (result.error) {
            this.stripeError = result.error.message;
            //console.log(result.error);
            this.loading = false;
          } else {
            this.token = result.token.id;
            window.config.token = result.token.id;
            this.loading = false;
            this.changeRoute("/signup#signup");
          }
        });
    },
    fixFields() {
      let fields = document.querySelectorAll(".__PrivateStripeElement-input");
      fields.forEach((item) => item.setAttribute("type", "text"));
      let inputs = document.querySelectorAll(".InputElement");
      inputs.forEach((item) => item.setAttribute("type", "text"));
    },
  }
}
</script>